/**
 * Common SVG defs (gradient, sparkle) cho illustrations.
 * Doc 31.
 */
import * as React from "react";

export interface IllustrationProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Gradient defs reused across illustrations. Each illustration includes
 * its own <defs> via this snippet to keep components self-contained.
 */
export function BrandGradientDefs({ id }: { id: string }): JSX.Element {
  return (
    <defs>
      <linearGradient id={`${id}-stroke`} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="hsl(var(--brand-from))" />
        <stop offset="50%" stopColor="hsl(var(--brand-via))" />
        <stop offset="100%" stopColor="hsl(var(--brand-to))" />
      </linearGradient>
      <linearGradient id={`${id}-fill`} x1="0%" y1="0%" x2="100%" y2="100%">
        <stop
          offset="0%"
          stopColor="hsl(var(--brand-from))"
          stopOpacity="0.12"
        />
        <stop offset="100%" stopColor="hsl(var(--brand-to))" stopOpacity="0.05" />
      </linearGradient>
    </defs>
  );
}

/** Decorative sparkle dấu * — gợi ý AI generated. */
export function Sparkle({
  cx,
  cy,
  size = 8,
  opacity = 0.8,
}: {
  cx: number;
  cy: number;
  size?: number;
  opacity?: number;
}): JSX.Element {
  return (
    <g opacity={opacity}>
      <path
        d={`M ${cx} ${cy - size} L ${cx + size * 0.3} ${cy - size * 0.3} L ${cx + size} ${cy} L ${cx + size * 0.3} ${cy + size * 0.3} L ${cx} ${cy + size} L ${cx - size * 0.3} ${cy + size * 0.3} L ${cx - size} ${cy} L ${cx - size * 0.3} ${cy - size * 0.3} Z`}
        fill="hsl(var(--brand-from))"
      />
    </g>
  );
}
